import request from '@/utils/request'

const tradeInventoryAdjustmentAttachmentApi = {
  trade_inventory_adjustment_attachment_list: '/trade/inventory_adjustment_attachment/',
  trade_inventory_adjustment_attachment_create: '/trade/inventory_adjustment_attachment/',
  trade_inventory_adjustment_attachment_update: '/trade/inventory_adjustment_attachment/',
  trade_inventory_adjustment_attachment_delete: '/trade/inventory_adjustment_attachment/'
}

/**
 * 列表
 */
export function inventory_adjustment_attachment_list (parameter) {
  return request({
    url: tradeInventoryAdjustmentAttachmentApi.trade_inventory_adjustment_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function inventory_adjustment_attachment_create (parameter) {
  return request({
    url: tradeInventoryAdjustmentAttachmentApi.trade_inventory_adjustment_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function inventory_adjustment_attachment_update (parameter, inventory_adjustment_attachment_id) {
  return request({
    url: tradeInventoryAdjustmentAttachmentApi.trade_inventory_adjustment_attachment_update + inventory_adjustment_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function inventory_adjustment_attachment_delete (inventory_adjustment_attachment_id) {
  return request({
    url: tradeInventoryAdjustmentAttachmentApi.trade_inventory_adjustment_attachment_delete + inventory_adjustment_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
